import { debounce } from 'lodash';
import React from 'react';
import { s as styles } from './viewer-inline-toolbar.rtlignore-2a312660.js';
import addTextSelectionListener from './TextSelectionListener.js';

class TextSelectionToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.addTextSelectionListener = (container) => {
      if (container && !this.removeTextSelectionListener) {
        this.removeTextSelectionListener = addTextSelectionListener(container, this.setSelectedText);
      }
    };
    this.setSelectedText = debounce(
      (selectedText, selectedTextPosition) => this.setState({ selectedText, selectedTextPosition }),
      50
    );
    this.state = { selectedText: "" };
  }
  componentDidMount() {
    this.addTextSelectionListener(this.props.container);
  }
  componentWillUnmount() {
    this.removeTextSelectionListener();
  }
  componentWillReceiveProps(nextPros) {
    this.addTextSelectionListener(nextPros.container);
  }
  render() {
    const { selectedText, selectedTextPosition } = this.state;
    const { container, children } = this.props;
    if (!selectedText || !selectedTextPosition) {
      return null;
    }
    const { left } = container.getBoundingClientRect();
    const topOffset = 5;
    const containerOffset = this.props.container.getBoundingClientRect().top;
    const style = {
      top: selectedTextPosition.y - containerOffset - topOffset - window.scrollY,
      left: selectedTextPosition.x - left
    };
    return /* @__PURE__ */ React.createElement("div", { className: styles.toolbar, style }, children(selectedText));
  }
}

export { TextSelectionToolbar as default };
//# sourceMappingURL=TextSelectionToolbar.js.map
